import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, Component } from 'react';
import UINavListItem from './UINavListItem';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import SyntheticEvent from '../core/SyntheticEvent';
import devLogger from 'react-utils/devLogger';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Context needed for the UIRouterSideNav component from the ui-addon-react-router-dom project.
 * UIRouterSideNav is rendering both SideNav and UISideNav.
 * Since UISideNavItem cannot work under SideNav, this context is used to determine when to
 * force the use of SideNavItem instead of it.
 */
const UIRouterSideNavContext = /*#__PURE__*/createContext({
  useTrellisComponents: false
});
const {
  Provider
} = UIRouterSideNavContext;
export { Provider as UIRouterSideNavContextProvider };

/**
 * A legacy wrapper for the SideNavItem component that handles deprecated props and
 * converts them to the new format expected by the SideNavItem component.
 */
const SideNavItemLegacy = props => {
  let {
    onOpenChange,
    href,
    linkComponent
  } = props;
  if (props.onOpenChange) {
    // onOpenChange was called with a synthetic event in UISideNavItem,
    // not just a boolean value like in SideNavItem
    onOpenChange = value => {
      var _props$onOpenChange;
      return (_props$onOpenChange = props.onOpenChange) === null || _props$onOpenChange === void 0 ? void 0 : _props$onOpenChange.call(props, SyntheticEvent(value));
    };
  }
  if (props.to) {
    // 'to' is deprecated in SideNavItem in favor of href.
    // If linkComponent is also provided, it should be removed since 'to' will not be passed along
    href = props.to;
    linkComponent = undefined;
  }
  if (process.env.NODE_ENV !== 'production') {
    devLogger.warn({
      message: `UIRouterSideNav: is rendering a SideNav component under the hood and it should not ` + `contain any UISideNavItem components in its component tree. ` + `Please replace all UISideNavItem components at any nesting level with SideNavItem, ` + `while migrating legacy props.`,
      key: 'UIRouterSideNav: replace UISideNavItem children with SideNavItem'
    });
  }
  return /*#__PURE__*/_jsx(SideNavItem, Object.assign({}, props, {
    onOpenChange: onOpenChange,
    href: href,
    linkComponent: linkComponent
  }));
};
export default class UISideNavItem extends Component {
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const uiRouterSideNavContext = this.context;

    // Renders SideNavItem if the context indicates that we should be using Trellis components.
    // Rendering Trellis components in this project should be generally avoided, but not in this case,
    // since UISideNavItem can end up being a descendant of SideNav
    if (uiRouterSideNavContext.useTrellisComponents) {
      return /*#__PURE__*/_jsx(SideNavItemLegacy, Object.assign({}, rest, {
        children: children
      }));
    }
    return /*#__PURE__*/_jsx(UINavListItem, Object.assign({
      iconRight: children != null ? 'down' : null
    }, rest, {
      children: children
    }));
  }
}
UISideNavItem.displayName = 'UISideNavItem';
UISideNavItem.contextType = UIRouterSideNavContext;
UISideNavItem.propTypes = Object.assign({}, UINavListItem.propTypes);
UISideNavItem.defaultProps = Object.assign({}, UINavListItem.defaultProps);